<cjm-content [loading]="loading">
	<div class="c-container-grid c-product-grid__grid">
		@for (product of products; track product) {
			<vloket-product-grid-item
				[product]="product"
				[hasFavouriteButton]="true"
				[actionInProgress]="actionInProgress"
				(setItemAsFavoriteClicked)="setItemAsFavoriteClicked.emit(product.id)"
				(removeItemAsFavoriteClicked)="removeItemAsFavoriteClicked.emit(product.id)"
			/>
		}
	</div>
</cjm-content>
